// Auto-generated from google-fonts metadata. Tuple form keeps bundle small.
// [familyName, category, availableWeights].
export type GoogleFontCategory = "sans-serif" | "serif" | "display" | "handwriting" | "monospace" | "icon";
export type GoogleFont = readonly [name: string, category: GoogleFontCategory, weights: readonly number[]];

export const GOOGLE_FONTS: readonly GoogleFont[] = [
  ["ABeeZee","sans-serif",[400]],
  ["ADLaM Display","display",[400]],
  ["AR One Sans","sans-serif",[400,500,600,700]],
  ["Abel","sans-serif",[400]],
  ["Abhaya Libre","serif",[400,500,600,700,800]],
  ["Aboreto","display",[400]],
  ["Abril Fatface","display",[400]],
  ["Abyssinica SIL","serif",[400]],
  ["Aclonica","sans-serif",[400]],
  ["Acme","sans-serif",[400]],
  ["Actor","sans-serif",[400]],
  ["Adamina","serif",[400]],
  ["Advent Pro","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Agdasima","sans-serif",[400,700]],
  ["Aguafina Script","handwriting",[400]],
  ["Akatab","sans-serif",[400,500,600,700,800,900]],
  ["Akaya Kanadaka","display",[400]],
  ["Akaya Telivigala","display",[400]],
  ["Akronim","display",[400]],
  ["Akshar","sans-serif",[300,400,500,600,700]],
  ["Aladin","display",[400]],
  ["Alata","sans-serif",[400]],
  ["Alatsi","sans-serif",[400]],
  ["Albert Sans","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Aldrich","sans-serif",[400]],
  ["Alef","sans-serif",[400,700]],
  ["Alegreya","serif",[400,500,600,700,800,900]],
  ["Alegreya SC","serif",[400,500,700,800,900]],
  ["Alegreya Sans","sans-serif",[100,300,400,500,700,800,900]],
  ["Alegreya Sans SC","sans-serif",[100,300,400,500,700,800,900]],
  ["Aleo","serif",[100,200,300,400,500,600,700,800,900]],
  ["Alex Brush","handwriting",[400]],
  ["Alexandria","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Alfa Slab One","display",[400]],
  ["Alice","serif",[400]],
  ["Alike","serif",[400]],
  ["Alike Angular","serif",[400]],
  ["Alkalami","serif",[400]],
  ["Alkatra","display",[400,500,600,700]],
  ["Allan","display",[400,700]],
  ["Allerta","sans-serif",[400]],
  ["Allerta Stencil","sans-serif",[400]],
  ["Allison","handwriting",[400]],
  ["Allura","handwriting",[400]],
  ["Almarai","sans-serif",[300,400,700,800]],
  ["Almendra","serif",[400,700]],
  ["Almendra Display","display",[400]],
  ["Almendra SC","serif",[400]],
  ["Alumni Sans","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Alumni Sans Collegiate One","sans-serif",[400]],
  ["Alumni Sans Inline One","display",[400]],
  ["Alumni Sans Pinstripe","sans-serif",[400]],
  ["Amarante","display",[400]],
  ["Amaranth","sans-serif",[400,700]],
  ["Amatic SC","handwriting",[400,700]],
  ["Amethysta","serif",[400]],
  ["Amiko","sans-serif",[400,600,700]],
  ["Amiri","serif",[400,700]],
  ["Amiri Quran","serif",[400]],
  ["Amita","handwriting",[400,700]],
  ["Anaheim","sans-serif",[400]],
  ["Andada Pro","serif",[400,500,600,700,800]],
  ["Andika","sans-serif",[400,700]],
  ["Anek Bangla","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Anek Devanagari","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Anek Gujarati","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Anek Gurmukhi","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Anek Kannada","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Anek Latin","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Anek Malayalam","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Anek Odia","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Anek Tamil","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Anek Telugu","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Angkor","display",[400]],
  ["Annie Use Your Telescope","handwriting",[400]],
  ["Anonymous Pro","monospace",[400,700]],
  ["Antic","sans-serif",[400]],
  ["Antic Didone","serif",[400]],
  ["Antic Slab","serif",[400]],
  ["Anton","sans-serif",[400]],
  ["Antonio","sans-serif",[100,200,300,400,500,600,700]],
  ["Anuphan","sans-serif",[100,200,300,400,500,600,700]],
  ["Anybody","display",[100,200,300,400,500,600,700,800,900]],
  ["Aoboshi One","serif",[400]],
  ["Arapey","serif",[400]],
  ["Arbutus","serif",[400]],
  ["Arbutus Slab","serif",[400]],
  ["Architects Daughter","handwriting",[400]],
  ["Archivo","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Archivo Black","sans-serif",[400]],
  ["Archivo Narrow","sans-serif",[400,500,600,700]],
  ["Are You Serious","handwriting",[400]],
  ["Aref Ruqaa","serif",[400,700]],
  ["Aref Ruqaa Ink","serif",[400,700]],
  ["Arima","display",[100,200,300,400,500,600,700]],
  ["Arima Madurai","display",[100,200,300,400,500,700,800,900]],
  ["Arimo","sans-serif",[400,500,600,700]],
  ["Arizonia","handwriting",[400]],
  ["Armata","sans-serif",[400]],
  ["Arsenal","sans-serif",[400,700]],
  ["Artifika","serif",[400]],
  ["Arvo","serif",[400,700]],
  ["Arya","sans-serif",[400,700]],
  ["Asap","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Asap Condensed","sans-serif",[200,300,400,500,600,700,800,900]],
  ["Asar","serif",[400]],
  ["Asset","display",[400]],
  ["Assistant","sans-serif",[200,300,400,500,600,700,800]],
  ["Astloch","display",[400,700]],
  ["Asul","sans-serif",[400,700]],
  ["Athiti","sans-serif",[200,300,400,500,600,700]],
  ["Atkinson Hyperlegible","sans-serif",[400,700]],
  ["Atma","display",[300,400,500,600,700]],
  ["Atomic Age","display",[400]],
  ["Aubrey","display",[400]],
  ["Audiowide","display",[400]],
  ["Autour One","display",[400]],
  ["Average","serif",[400]],
  ["Average Sans","sans-serif",[400]],
  ["Averia Gruesa Libre","display",[400]],
  ["Averia Libre","display",[300,400,700]],
  ["Averia Sans Libre","display",[300,400,700]],
  ["Averia Serif Libre","display",[300,400,700]],
  ["Azeret Mono","monospace",[100,200,300,400,500,600,700,800,900]],
  ["B612","sans-serif",[400,700]],
  ["B612 Mono","monospace",[400,700]],
  ["BIZ UDGothic","sans-serif",[400,700]],
  ["BIZ UDMincho","serif",[400,700]],
  ["BIZ UDPGothic","sans-serif",[400,700]],
  ["BIZ UDPMincho","serif",[400,700]],
  ["Babylonica","handwriting",[400]],
  ["Bacasime Antique","serif",[400]],
  ["Bad Script","handwriting",[400]],
  ["Bagel Fat One","display",[400]],
  ["Bahiana","display",[400]],
  ["Bahianita","display",[400]],
  ["Bai Jamjuree","sans-serif",[200,300,400,500,600,700]],
  ["Bakbak One","display",[400]],
  ["Ballet","handwriting",[400]],
  ["Baloo 2","display",[400,500,600,700,800]],
  ["Baloo Bhai 2","display",[400,500,600,700,800]],
  ["Baloo Bhaijaan 2","display",[400,500,600,700,800]],
  ["Baloo Bhaina 2","display",[400,500,600,700,800]],
  ["Baloo Chettan 2","display",[400,500,600,700,800]],
  ["Baloo Da 2","display",[400,500,600,700,800]],
  ["Baloo Paaji 2","display",[400,500,600,700,800]],
  ["Baloo Tamma 2","display",[400,500,600,700,800]],
  ["Baloo Tammudu 2","display",[400,500,600,700,800]],
  ["Baloo Thambi 2","display",[400,500,600,700,800]],
  ["Balsamiq Sans","display",[400,700]],
  ["Balthazar","serif",[400]],
  ["Bangers","display",[400]],
  ["Barlow","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Barlow Condensed","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Barlow Semi Condensed","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Barriecito","display",[400]],
  ["Barrio","display",[400]],
  ["Basic","sans-serif",[400]],
  ["Baskervville","serif",[400]],
  ["Battambang","display",[100,300,400,700,900]],
  ["Baumans","display",[400]],
  ["Bayon","sans-serif",[400]],
  ["Be Vietnam Pro","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Beau Rivage","handwriting",[400]],
  ["Bebas Neue","sans-serif",[400]],
  ["Belanosima","sans-serif",[400,600,700]],
  ["Belgrano","serif",[400]],
  ["Bellefair","serif",[400]],
  ["Belleza","sans-serif",[400]],
  ["Bellota","display",[300,400,700]],
  ["Bellota Text","display",[300,400,700]],
  ["BenchNine","sans-serif",[300,400,700]],
  ["Benne","serif",[400]],
  ["Bentham","serif",[400]],
  ["Berkshire Swash","handwriting",[400]],
  ["Besley","serif",[400,500,600,700,800,900]],
  ["Beth Ellen","handwriting",[400]],
  ["Bevan","serif",[400]],
  ["BhuTuka Expanded One","serif",[400]],
  ["Big Shoulders Display","display",[100,200,300,400,500,600,700,800,900]],
  ["Big Shoulders Inline Display","display",[100,200,300,400,500,600,700,800,900]],
  ["Big Shoulders Inline Text","display",[100,200,300,400,500,600,700,800,900]],
  ["Big Shoulders Stencil Display","display",[100,200,300,400,500,600,700,800,900]],
  ["Big Shoulders Stencil Text","display",[100,200,300,400,500,600,700,800,900]],
  ["Big Shoulders Text","display",[100,200,300,400,500,600,700,800,900]],
  ["Bigelow Rules","display",[400]],
  ["Bigshot One","display",[400]],
  ["Bilbo","handwriting",[400]],
  ["Bilbo Swash Caps","handwriting",[400]],
  ["BioRhyme","serif",[200,300,400,700,800]],
  ["BioRhyme Expanded","serif",[200,300,400,700,800]],
  ["Birthstone","handwriting",[400]],
  ["Birthstone Bounce","handwriting",[400,500]],
  ["Biryani","sans-serif",[200,300,400,600,700,800,900]],
  ["Bitter","serif",[100,200,300,400,500,600,700,800,900]],
  ["Black And White Picture","display",[400]],
  ["Black Han Sans","sans-serif",[400]],
  ["Black Ops One","display",[400]],
  ["Blaka","display",[400]],
  ["Blaka Hollow","display",[400]],
  ["Blaka Ink","display",[400]],
  ["Blinker","sans-serif",[100,200,300,400,600,700,800,900]],
  ["Bodoni Moda","serif",[400,500,600,700,800,900]],
  ["Bokor","display",[400]],
  ["Bona Nova","serif",[400,700]],
  ["Bonbon","handwriting",[400]],
  ["Bonheur Royale","handwriting",[400]],
  ["Boogaloo","display",[400]],
  ["Borel","handwriting",[400]],
  ["Bowlby One","display",[400]],
  ["Bowlby One SC","display",[400]],
  ["Braah One","sans-serif",[400]],
  ["Brawler","serif",[400,700]],
  ["Bree Serif","serif",[400]],
  ["Bricolage Grotesque","sans-serif",[200,300,400,500,600,700,800]],
  ["Bruno Ace","display",[400]],
  ["Bruno Ace SC","display",[400]],
  ["Brygada 1918","serif",[400,500,600,700]],
  ["Bubblegum Sans","display",[400]],
  ["Bubbler One","sans-serif",[400]],
  ["Buda","display",[300]],
  ["Buenard","serif",[400,700]],
  ["Bungee","display",[400]],
  ["Bungee Hairline","display",[400]],
  ["Bungee Inline","display",[400]],
  ["Bungee Outline","display",[400]],
  ["Bungee Shade","display",[400]],
  ["Bungee Spice","display",[400]],
  ["Butcherman","display",[400]],
  ["Butterfly Kids","handwriting",[400]],
  ["Cabin","sans-serif",[400,500,600,700]],
  ["Cabin Condensed","sans-serif",[400,500,600,700]],
  ["Cabin Sketch","display",[400,700]],
  ["Caesar Dressing","display",[400]],
  ["Cagliostro","sans-serif",[400]],
  ["Cairo","sans-serif",[200,300,400,500,600,700,800,900]],
  ["Cairo Play","sans-serif",[200,300,400,500,600,700,800,900]],
  ["Caladea","serif",[400,700]],
  ["Calistoga","display",[400]],
  ["Calligraffitti","handwriting",[400]],
  ["Cambay","sans-serif",[400,700]],
  ["Cambo","serif",[400]],
  ["Candal","sans-serif",[400]],
  ["Cantarell","sans-serif",[400,700]],
  ["Cantata One","serif",[400]],
  ["Cantora One","sans-serif",[400]],
  ["Caprasimo","display",[400]],
  ["Capriola","sans-serif",[400]],
  ["Caramel","handwriting",[400]],
  ["Carattere","handwriting",[400]],
  ["Cardo","serif",[400,700]],
  ["Carlito","sans-serif",[400,700]],
  ["Carme","sans-serif",[400]],
  ["Carrois Gothic","sans-serif",[400]],
  ["Carrois Gothic SC","sans-serif",[400]],
  ["Carter One","display",[400]],
  ["Castoro","serif",[400]],
  ["Castoro Titling","display",[400]],
  ["Catamaran","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Caudex","serif",[400,700]],
  ["Caveat","handwriting",[400,500,600,700]],
  ["Caveat Brush","handwriting",[400]],
  ["Cedarville Cursive","handwriting",[400]],
  ["Ceviche One","display",[400]],
  ["Chakra Petch","sans-serif",[300,400,500,600,700]],
  ["Changa","sans-serif",[200,300,400,500,600,700,800]],
  ["Changa One","display",[400]],
  ["Chango","display",[400]],
  ["Charis SIL","serif",[400,700]],
  ["Charm","handwriting",[400,700]],
  ["Charmonman","handwriting",[400,700]],
  ["Chathura","sans-serif",[100,300,400,700,800]],
  ["Chau Philomene One","sans-serif",[400]],
  ["Chela One","display",[400]],
  ["Chelsea Market","display",[400]],
  ["Chenla","display",[400]],
  ["Cherish","handwriting",[400]],
  ["Cherry Bomb One","display",[400]],
  ["Cherry Cream Soda","display",[400]],
  ["Cherry Swash","display",[400,700]],
  ["Chewy","display",[400]],
  ["Chicle","display",[400]],
  ["Chilanka","handwriting",[400]],
  ["Chivo","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Chivo Mono","monospace",[100,200,300,400,500,600,700,800,900]],
  ["Chokokutai","display",[400]],
  ["Chonburi","display",[400]],
  ["Cinzel","serif",[400,500,600,700,800,900]],
  ["Cinzel Decorative","display",[400,700,900]],
  ["Clicker Script","handwriting",[400]],
  ["Climate Crisis","display",[400]],
  ["Coda","display",[400,800]],
  ["Coda Caption","sans-serif",[800]],
  ["Codystar","display",[300,400]],
  ["Coiny","display",[400]],
  ["Combo","display",[400]],
  ["Comfortaa","display",[300,400,500,600,700]],
  ["Comforter","handwriting",[400]],
  ["Comforter Brush","handwriting",[400]],
  ["Comic Neue","handwriting",[300,400,700]],
  ["Coming Soon","handwriting",[400]],
  ["Comme","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Commissioner","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Concert One","display",[400]],
  ["Condiment","handwriting",[400]],
  ["Content","display",[400,700]],
  ["Contrail One","display",[400]],
  ["Convergence","sans-serif",[400]],
  ["Cookie","handwriting",[400]],
  ["Copse","serif",[400]],
  ["Corben","display",[400,700]],
  ["Corinthia","handwriting",[400,700]],
  ["Cormorant","serif",[300,400,500,600,700]],
  ["Cormorant Garamond","serif",[300,400,500,600,700]],
  ["Cormorant Infant","serif",[300,400,500,600,700]],
  ["Cormorant SC","serif",[300,400,500,600,700]],
  ["Cormorant Unicase","serif",[300,400,500,600,700]],
  ["Cormorant Upright","serif",[300,400,500,600,700]],
  ["Courgette","handwriting",[400]],
  ["Courier Prime","monospace",[400,700]],
  ["Cousine","monospace",[400,700]],
  ["Coustard","serif",[400,900]],
  ["Covered By Your Grace","handwriting",[400]],
  ["Crafty Girls","handwriting",[400]],
  ["Creepster","display",[400]],
  ["Crete Round","serif",[400]],
  ["Crimson Pro","serif",[200,300,400,500,600,700,800,900]],
  ["Crimson Text","serif",[400,600,700]],
  ["Croissant One","display",[400]],
  ["Crushed","display",[400]],
  ["Cuprum","sans-serif",[400,500,600,700]],
  ["Cute Font","display",[400]],
  ["Cutive","serif",[400]],
  ["Cutive Mono","monospace",[400]],
  ["DM Mono","monospace",[300,400,500]],
  ["DM Sans","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["DM Serif Display","serif",[400]],
  ["DM Serif Text","serif",[400]],
  ["Dai Banna SIL","serif",[300,400,500,600,700]],
  ["Damion","handwriting",[400]],
  ["Dancing Script","handwriting",[400,500,600,700]],
  ["Dangrek","display",[400]],
  ["Darker Grotesque","sans-serif",[300,400,500,600,700,800,900]],
  ["Darumadrop One","display",[400]],
  ["David Libre","serif",[400,500,700]],
  ["Dawning of a New Day","handwriting",[400]],
  ["Days One","sans-serif",[400]],
  ["Dekko","handwriting",[400]],
  ["Dela Gothic One","display",[400]],
  ["Delicious Handrawn","handwriting",[400]],
  ["Delius","handwriting",[400]],
  ["Delius Swash Caps","handwriting",[400]],
  ["Delius Unicase","handwriting",[400,700]],
  ["Della Respira","serif",[400]],
  ["Denk One","sans-serif",[400]],
  ["Devonshire","handwriting",[400]],
  ["Dhurjati","sans-serif",[400]],
  ["Didact Gothic","sans-serif",[400]],
  ["Diphylleia","serif",[400]],
  ["Diplomata","display",[400]],
  ["Diplomata SC","display",[400]],
  ["Do Hyeon","sans-serif",[400]],
  ["Dokdo","display",[400]],
  ["Domine","serif",[400,500,600,700]],
  ["Donegal One","serif",[400]],
  ["Dongle","sans-serif",[300,400,700]],
  ["Doppio One","sans-serif",[400]],
  ["Dorsa","sans-serif",[400]],
  ["Dosis","sans-serif",[200,300,400,500,600,700,800]],
  ["DotGothic16","sans-serif",[400]],
  ["Dr Sugiyama","handwriting",[400]],
  ["Duru Sans","sans-serif",[400]],
  ["DynaPuff","display",[400,500,600,700]],
  ["Dynalight","display",[400]],
  ["EB Garamond","serif",[400,500,600,700,800]],
  ["Eagle Lake","handwriting",[400]],
  ["East Sea Dokdo","handwriting",[400]],
  ["Eater","display",[400]],
  ["Economica","sans-serif",[400,700]],
  ["Eczar","serif",[400,500,600,700,800]],
  ["Edu NSW ACT Foundation","handwriting",[400,500,600,700]],
  ["Edu QLD Beginner","handwriting",[400,500,600,700]],
  ["Edu SA Beginner","handwriting",[400,500,600,700]],
  ["Edu TAS Beginner","handwriting",[400,500,600,700]],
  ["Edu VIC WA NT Beginner","handwriting",[400,500,600,700]],
  ["El Messiri","sans-serif",[400,500,600,700]],
  ["Electrolize","sans-serif",[400]],
  ["Elsie","display",[400,900]],
  ["Elsie Swash Caps","display",[400,900]],
  ["Emblema One","display",[400]],
  ["Emilys Candy","display",[400]],
  ["Encode Sans","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Encode Sans Condensed","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Encode Sans Expanded","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Encode Sans SC","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Encode Sans Semi Condensed","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Encode Sans Semi Expanded","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Engagement","handwriting",[400]],
  ["Englebert","sans-serif",[400]],
  ["Enriqueta","serif",[400,500,600,700]],
  ["Ephesis","handwriting",[400]],
  ["Epilogue","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Erica One","display",[400]],
  ["Esteban","serif",[400]],
  ["Estonia","handwriting",[400]],
  ["Euphoria Script","handwriting",[400]],
  ["Ewert","display",[400]],
  ["Exo","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Exo 2","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Expletus Sans","display",[400,500,600,700]],
  ["Explora","handwriting",[400]],
  ["Fahkwang","sans-serif",[200,300,400,500,600,700]],
  ["Familjen Grotesk","sans-serif",[400,500,600,700]],
  ["Fanwood Text","serif",[400]],
  ["Farro","sans-serif",[300,400,500,700]],
  ["Farsan","display",[400]],
  ["Fascinate","display",[400]],
  ["Fascinate Inline","display",[400]],
  ["Faster One","display",[400]],
  ["Fasthand","display",[400]],
  ["Fauna One","serif",[400]],
  ["Faustina","serif",[300,400,500,600,700,800]],
  ["Federant","display",[400]],
  ["Federo","sans-serif",[400]],
  ["Felipa","handwriting",[400]],
  ["Fenix","serif",[400]],
  ["Festive","handwriting",[400]],
  ["Figtree","sans-serif",[300,400,500,600,700,800,900]],
  ["Finger Paint","display",[400]],
  ["Finlandica","sans-serif",[400,500,600,700]],
  ["Fira Code","monospace",[300,400,500,600,700]],
  ["Fira Mono","monospace",[400,500,700]],
  ["Fira Sans","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Fira Sans Condensed","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Fira Sans Extra Condensed","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Fjalla One","sans-serif",[400]],
  ["Fjord One","serif",[400]],
  ["Flamenco","display",[300,400]],
  ["Flavors","display",[400]],
  ["Fleur De Leah","handwriting",[400]],
  ["Flow Block","display",[400]],
  ["Flow Circular","display",[400]],
  ["Flow Rounded","display",[400]],
  ["Foldit","display",[100,200,300,400,500,600,700,800,900]],
  ["Fondamento","handwriting",[400]],
  ["Fontdiner Swanky","display",[400]],
  ["Forum","display",[400]],
  ["Fragment Mono","monospace",[400]],
  ["Francois One","sans-serif",[400]],
  ["Frank Ruhl Libre","serif",[300,400,500,600,700,800,900]],
  ["Fraunces","serif",[100,200,300,400,500,600,700,800,900]],
  ["Freckle Face","display",[400]],
  ["Fredericka the Great","display",[400]],
  ["Fredoka","sans-serif",[300,400,500,600,700]],
  ["Freehand","display",[400]],
  ["Fresca","sans-serif",[400]],
  ["Frijole","display",[400]],
  ["Fruktur","display",[400]],
  ["Fugaz One","display",[400]],
  ["Fuggles","handwriting",[400]],
  ["Fuzzy Bubbles","handwriting",[400,700]],
  ["GFS Didot","serif",[400]],
  ["GFS Neohellenic","sans-serif",[400,700]],
  ["Gabarito","display",[400,500,600,700,800,900]],
  ["Gabriela","serif",[400]],
  ["Gaegu","handwriting",[300,400,700]],
  ["Gafata","sans-serif",[400]],
  ["Gajraj One","display",[400]],
  ["Galada","display",[400]],
  ["Galdeano","sans-serif",[400]],
  ["Galindo","display",[400]],
  ["Gamja Flower","handwriting",[400]],
  ["Gantari","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Gasoek One","sans-serif",[400]],
  ["Gayathri","sans-serif",[100,400,700]],
  ["Gelasio","serif",[400,500,600,700]],
  ["Gemunu Libre","sans-serif",[200,300,400,500,600,700,800]],
  ["Genos","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Gentium Book Plus","serif",[400,700]],
  ["Gentium Plus","serif",[400,700]],
  ["Geo","sans-serif",[400]],
  ["Geologica","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Georama","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Geostar","display",[400]],
  ["Geostar Fill","display",[400]],
  ["Germania One","display",[400]],
  ["Gideon Roman","display",[400]],
  ["Gidugu","sans-serif",[400]],
  ["Gilda Display","serif",[400]],
  ["Girassol","display",[400]],
  ["Give You Glory","handwriting",[400]],
  ["Glass Antiqua","display",[400]],
  ["Glegoo","serif",[400,700]],
  ["Gloock","serif",[400]],
  ["Gloria Hallelujah","handwriting",[400]],
  ["Glory","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Gluten","display",[100,200,300,400,500,600,700,800,900]],
  ["Goblin One","display",[400]],
  ["Gochi Hand","handwriting",[400]],
  ["Goldman","display",[400,700]],
  ["Golos Text","sans-serif",[400,500,600,700,800,900]],
  ["Gorditas","display",[400,700]],
  ["Gothic A1","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Gotu","sans-serif",[400]],
  ["Goudy Bookletter 1911","serif",[400]],
  ["Gowun Batang","serif",[400,700]],
  ["Gowun Dodum","sans-serif",[400]],
  ["Graduate","serif",[400]],
  ["Grand Hotel","handwriting",[400]],
  ["Grandiflora One","serif",[400]],
  ["Grandstander","display",[100,200,300,400,500,600,700,800,900]],
  ["Grape Nuts","handwriting",[400]],
  ["Gravitas One","display",[400]],
  ["Great Vibes","handwriting",[400]],
  ["Grechen Fuemen","handwriting",[400]],
  ["Grenze","serif",[100,200,300,400,500,600,700,800,900]],
  ["Grenze Gotisch","display",[100,200,300,400,500,600,700,800,900]],
  ["Grey Qo","handwriting",[400]],
  ["Griffy","display",[400]],
  ["Gruppo","sans-serif",[400]],
  ["Gudea","sans-serif",[400,700]],
  ["Gugi","display",[400]],
  ["Gulzar","serif",[400]],
  ["Gupter","serif",[400,500,700]],
  ["Gurajada","serif",[400]],
  ["Gwendolyn","handwriting",[400,700]],
  ["Habibi","serif",[400]],
  ["Hachi Maru Pop","handwriting",[400]],
  ["Hahmlet","serif",[100,200,300,400,500,600,700,800,900]],
  ["Halant","serif",[300,400,500,600,700]],
  ["Hammersmith One","sans-serif",[400]],
  ["Hanalei","display",[400]],
  ["Hanalei Fill","display",[400]],
  ["Handjet","display",[100,200,300,400,500,600,700,800,900]],
  ["Handlee","handwriting",[400]],
  ["Hanken Grotesk","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Hanuman","serif",[100,300,400,700,900]],
  ["Happy Monkey","display",[400]],
  ["Harmattan","sans-serif",[400,500,600,700]],
  ["Headland One","serif",[400]],
  ["Heebo","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Henny Penny","display",[400]],
  ["Hepta Slab","serif",[100,200,300,400,500,600,700,800,900]],
  ["Herr Von Muellerhoff","handwriting",[400]],
  ["Hi Melody","handwriting",[400]],
  ["Hina Mincho","serif",[400]],
  ["Hind","sans-serif",[300,400,500,600,700]],
  ["Hind Guntur","sans-serif",[300,400,500,600,700]],
  ["Hind Madurai","sans-serif",[300,400,500,600,700]],
  ["Hind Siliguri","sans-serif",[300,400,500,600,700]],
  ["Hind Vadodara","sans-serif",[300,400,500,600,700]],
  ["Holtwood One SC","serif",[400]],
  ["Homemade Apple","handwriting",[400]],
  ["Homenaje","sans-serif",[400]],
  ["Hubballi","sans-serif",[400]],
  ["Hurricane","handwriting",[400]],
  ["IBM Plex Mono","monospace",[100,200,300,400,500,600,700]],
  ["IBM Plex Sans","sans-serif",[100,200,300,400,500,600,700]],
  ["IBM Plex Sans Arabic","sans-serif",[100,200,300,400,500,600,700]],
  ["IBM Plex Sans Condensed","sans-serif",[100,200,300,400,500,600,700]],
  ["IBM Plex Sans Devanagari","sans-serif",[100,200,300,400,500,600,700]],
  ["IBM Plex Sans Hebrew","sans-serif",[100,200,300,400,500,600,700]],
  ["IBM Plex Sans JP","sans-serif",[100,200,300,400,500,600,700]],
  ["IBM Plex Sans KR","sans-serif",[100,200,300,400,500,600,700]],
  ["IBM Plex Sans Thai","sans-serif",[100,200,300,400,500,600,700]],
  ["IBM Plex Sans Thai Looped","sans-serif",[100,200,300,400,500,600,700]],
  ["IBM Plex Serif","serif",[100,200,300,400,500,600,700]],
  ["IM Fell DW Pica","serif",[400]],
  ["IM Fell DW Pica SC","serif",[400]],
  ["IM Fell Double Pica","serif",[400]],
  ["IM Fell Double Pica SC","serif",[400]],
  ["IM Fell English","serif",[400]],
  ["IM Fell English SC","serif",[400]],
  ["IM Fell French Canon","serif",[400]],
  ["IM Fell French Canon SC","serif",[400]],
  ["IM Fell Great Primer","serif",[400]],
  ["IM Fell Great Primer SC","serif",[400]],
  ["Ibarra Real Nova","serif",[400,500,600,700]],
  ["Iceberg","display",[400]],
  ["Iceland","display",[400]],
  ["Imbue","serif",[100,200,300,400,500,600,700,800,900]],
  ["Imperial Script","handwriting",[400]],
  ["Imprima","sans-serif",[400]],
  ["Inclusive Sans","sans-serif",[400]],
  ["Inconsolata","monospace",[200,300,400,500,600,700,800,900]],
  ["Inder","sans-serif",[400]],
  ["Indie Flower","handwriting",[400]],
  ["Ingrid Darling","handwriting",[400]],
  ["Inika","serif",[400,700]],
  ["Inknut Antiqua","serif",[300,400,500,600,700,800,900]],
  ["Inria Sans","sans-serif",[300,400,700]],
  ["Inria Serif","serif",[300,400,700]],
  ["Inspiration","handwriting",[400]],
  ["Instrument Sans","sans-serif",[400,500,600,700]],
  ["Instrument Serif","serif",[400]],
  ["Inter","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Inter Tight","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Irish Grover","display",[400]],
  ["Island Moments","handwriting",[400]],
  ["Istok Web","sans-serif",[400,700]],
  ["Italiana","serif",[400]],
  ["Italianno","handwriting",[400]],
  ["Itim","handwriting",[400]],
  ["Jacques Francois","serif",[400]],
  ["Jacques Francois Shadow","display",[400]],
  ["Jaldi","sans-serif",[400,700]],
  ["JetBrains Mono","monospace",[100,200,300,400,500,600,700,800]],
  ["Jim Nightshade","handwriting",[400]],
  ["Joan","serif",[400]],
  ["Jockey One","sans-serif",[400]],
  ["Jolly Lodger","display",[400]],
  ["Jomhuria","display",[400]],
  ["Jomolhari","serif",[400]],
  ["Josefin Sans","sans-serif",[100,200,300,400,500,600,700]],
  ["Josefin Slab","serif",[100,200,300,400,500,600,700]],
  ["Jost","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Joti One","display",[400]],
  ["Jua","sans-serif",[400]],
  ["Judson","serif",[400,700]],
  ["Julee","handwriting",[400]],
  ["Julius Sans One","sans-serif",[400]],
  ["Junge","serif",[400]],
  ["Jura","sans-serif",[300,400,500,600,700]],
  ["Just Another Hand","handwriting",[400]],
  ["Just Me Again Down Here","handwriting",[400]],
  ["K2D","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Kablammo","display",[400]],
  ["Kadwa","serif",[400,700]],
  ["Kaisei Decol","serif",[400,500,700]],
  ["Kaisei HarunoUmi","serif",[400,500,700]],
  ["Kaisei Opti","serif",[400,500,700]],
  ["Kaisei Tokumin","serif",[400,500,700,800]],
  ["Kalam","handwriting",[300,400,700]],
  ["Kameron","serif",[400,500,600,700]],
  ["Kanit","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Kantumruy Pro","sans-serif",[100,200,300,400,500,600,700]],
  ["Karantina","display",[300,400,700]],
  ["Karla","sans-serif",[200,300,400,500,600,700,800]],
  ["Karma","serif",[300,400,500,600,700]],
  ["Katibeh","display",[400]],
  ["Kaushan Script","handwriting",[400]],
  ["Kavivanar","handwriting",[400]],
  ["Kavoon","display",[400]],
  ["Kdam Thmor Pro","sans-serif",[400]],
  ["Keania One","display",[400]],
  ["Kelly Slab","display",[400]],
  ["Kenia","display",[400]],
  ["Khand","sans-serif",[300,400,500,600,700]],
  ["Khmer","sans-serif",[400]],
  ["Khula","sans-serif",[300,400,600,700,800]],
  ["Kings","handwriting",[400]],
  ["Kirang Haerang","display",[400]],
  ["Kite One","sans-serif",[400]],
  ["Kiwi Maru","serif",[300,400,500]],
  ["Klee One","handwriting",[400,600]],
  ["Knewave","display",[400]],
  ["KoHo","sans-serif",[200,300,400,500,600,700]],
  ["Kodchasan","sans-serif",[200,300,400,500,600,700]],
  ["Koh Santepheap","serif",[100,300,400,700,900]],
  ["Kolker Brush","handwriting",[400]],
  ["Konkhmer Sleokchher","display",[400]],
  ["Kosugi","sans-serif",[400]],
  ["Kosugi Maru","sans-serif",[400]],
  ["Kotta One","serif",[400]],
  ["Koulen","display",[400]],
  ["Kranky","display",[400]],
  ["Kreon","serif",[300,400,500,600,700]],
  ["Kristi","handwriting",[400]],
  ["Krona One","sans-serif",[400]],
  ["Krub","sans-serif",[200,300,400,500,600,700]],
  ["Kufam","sans-serif",[400,500,600,700,800,900]],
  ["Kulim Park","sans-serif",[200,300,400,600,700]],
  ["Kumar One","display",[400]],
  ["Kumar One Outline","display",[400]],
  ["Kumbh Sans","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Kurale","serif",[400]],
  ["La Belle Aurore","handwriting",[400]],
  ["Labrada","serif",[100,200,300,400,500,600,700,800,900]],
  ["Lacquer","display",[400]],
  ["Laila","sans-serif",[300,400,500,600,700]],
  ["Lakki Reddy","handwriting",[400]],
  ["Lalezar","display",[400]],
  ["Lancelot","display",[400]],
  ["Langar","display",[400]],
  ["Lateef","serif",[200,300,400,500,600,700,800]],
  ["Lato","sans-serif",[100,300,400,700,900]],
  ["Lavishly Yours","handwriting",[400]],
  ["League Gothic","sans-serif",[400]],
  ["League Script","handwriting",[400]],
  ["League Spartan","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Leckerli One","handwriting",[400]],
  ["Ledger","serif",[400]],
  ["Lekton","sans-serif",[400,700]],
  ["Lemon","display",[400]],
  ["Lemonada","display",[300,400,500,600,700]],
  ["Lexend","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Lexend Deca","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Lexend Exa","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Lexend Giga","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Lexend Mega","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Lexend Peta","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Lexend Tera","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Lexend Zetta","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Libre Barcode 128","display",[400]],
  ["Libre Barcode 128 Text","display",[400]],
  ["Libre Barcode 39","display",[400]],
  ["Libre Barcode 39 Extended","display",[400]],
  ["Libre Barcode 39 Extended Text","display",[400]],
  ["Libre Barcode 39 Text","display",[400]],
  ["Libre Barcode EAN13 Text","display",[400]],
  ["Libre Baskerville","serif",[400,700]],
  ["Libre Bodoni","serif",[400,500,600,700]],
  ["Libre Caslon Display","serif",[400]],
  ["Libre Caslon Text","serif",[400,700]],
  ["Libre Franklin","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Licorice","handwriting",[400]],
  ["Life Savers","display",[400,700,800]],
  ["Lilita One","display",[400]],
  ["Lily Script One","display",[400]],
  ["Limelight","display",[400]],
  ["Linden Hill","serif",[400]],
  ["Lisu Bosa","serif",[200,300,400,500,600,700,800,900]],
  ["Literata","serif",[200,300,400,500,600,700,800,900]],
  ["Liu Jian Mao Cao","handwriting",[400]],
  ["Livvic","sans-serif",[100,200,300,400,500,600,700,900]],
  ["Lobster","display",[400]],
  ["Lobster Two","display",[400,700]],
  ["Londrina Outline","display",[400]],
  ["Londrina Shadow","display",[400]],
  ["Londrina Sketch","display",[400]],
  ["Londrina Solid","display",[100,300,400,900]],
  ["Long Cang","handwriting",[400]],
  ["Lora","serif",[400,500,600,700]],
  ["Love Light","handwriting",[400]],
  ["Love Ya Like A Sister","display",[400]],
  ["Loved by the King","handwriting",[400]],
  ["Lovers Quarrel","handwriting",[400]],
  ["Luckiest Guy","display",[400]],
  ["Lugrasimo","handwriting",[400]],
  ["Lumanosimo","handwriting",[400]],
  ["Lunasima","sans-serif",[400,700]],
  ["Lusitana","serif",[400,700]],
  ["Lustria","serif",[400]],
  ["Luxurious Roman","display",[400]],
  ["Luxurious Script","handwriting",[400]],
  ["M PLUS 1","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["M PLUS 1 Code","monospace",[100,200,300,400,500,600,700]],
  ["M PLUS 1p","sans-serif",[100,300,400,500,700,800,900]],
  ["M PLUS 2","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["M PLUS Code Latin","sans-serif",[100,200,300,400,500,600,700]],
  ["M PLUS Rounded 1c","sans-serif",[100,300,400,500,700,800,900]],
  ["Ma Shan Zheng","handwriting",[400]],
  ["Macondo","display",[400]],
  ["Macondo Swash Caps","display",[400]],
  ["Mada","sans-serif",[200,300,400,500,600,700,800,900]],
  ["Magra","sans-serif",[400,700]],
  ["Maiden Orange","serif",[400]],
  ["Maitree","serif",[200,300,400,500,600,700]],
  ["Major Mono Display","monospace",[400]],
  ["Mako","sans-serif",[400]],
  ["Mali","handwriting",[200,300,400,500,600,700]],
  ["Mallanna","sans-serif",[400]],
  ["Mandali","sans-serif",[400]],
  ["Manjari","sans-serif",[100,400,700]],
  ["Manrope","sans-serif",[200,300,400,500,600,700,800]],
  ["Mansalva","handwriting",[400]],
  ["Manuale","serif",[300,400,500,600,700,800]],
  ["Marcellus","serif",[400]],
  ["Marcellus SC","serif",[400]],
  ["Marck Script","handwriting",[400]],
  ["Margarine","display",[400]],
  ["Marhey","display",[300,400,500,600,700]],
  ["Markazi Text","serif",[400,500,600,700]],
  ["Marko One","serif",[400]],
  ["Marmelad","sans-serif",[400]],
  ["Martel","serif",[200,300,400,600,700,800,900]],
  ["Martel Sans","sans-serif",[200,300,400,600,700,800,900]],
  ["Martian Mono","monospace",[100,200,300,400,500,600,700,800]],
  ["Marvel","sans-serif",[400,700]],
  ["Mate","serif",[400]],
  ["Mate SC","serif",[400]],
  ["Material Icons","icon",[400]],
  ["Material Icons Outlined","monospace",[400]],
  ["Material Icons Round","monospace",[400]],
  ["Material Icons Sharp","monospace",[400]],
  ["Material Icons Two Tone","monospace",[400]],
  ["Material Symbols Outlined","monospace",[100,200,300,400,500,600,700]],
  ["Material Symbols Rounded","monospace",[100,200,300,400,500,600,700]],
  ["Material Symbols Sharp","monospace",[100,200,300,400,500,600,700]],
  ["Maven Pro","sans-serif",[400,500,600,700,800,900]],
  ["McLaren","display",[400]],
  ["Mea Culpa","handwriting",[400]],
  ["Meddon","handwriting",[400]],
  ["MedievalSharp","display",[400]],
  ["Medula One","display",[400]],
  ["Meera Inimai","sans-serif",[400]],
  ["Megrim","display",[400]],
  ["Meie Script","handwriting",[400]],
  ["Meow Script","handwriting",[400]],
  ["Merienda","handwriting",[300,400,500,600,700,800,900]],
  ["Merriweather","serif",[300,400,700,900]],
  ["Merriweather Sans","sans-serif",[300,400,500,600,700,800]],
  ["Metal","display",[400]],
  ["Metal Mania","display",[400]],
  ["Metamorphous","display",[400]],
  ["Metrophobic","sans-serif",[400]],
  ["Michroma","sans-serif",[400]],
  ["Milonga","display",[400]],
  ["Miltonian","display",[400]],
  ["Miltonian Tattoo","display",[400]],
  ["Mina","sans-serif",[400,700]],
  ["Mingzat","sans-serif",[400]],
  ["Miniver","display",[400]],
  ["Miriam Libre","sans-serif",[400,700]],
  ["Mirza","serif",[400,500,600,700]],
  ["Miss Fajardose","handwriting",[400]],
  ["Mitr","sans-serif",[200,300,400,500,600,700]],
  ["Mochiy Pop One","sans-serif",[400]],
  ["Mochiy Pop P One","sans-serif",[400]],
  ["Modak","display",[400]],
  ["Modern Antiqua","display",[400]],
  ["Mogra","display",[400]],
  ["Mohave","sans-serif",[300,400,500,600,700]],
  ["Moirai One","display",[400]],
  ["Molengo","sans-serif",[400]],
  ["Molle","handwriting",[400]],
  ["Monda","sans-serif",[400,700]],
  ["Monofett","monospace",[400]],
  ["Monomaniac One","sans-serif",[400]],
  ["Monoton","display",[400]],
  ["Monsieur La Doulaise","handwriting",[400]],
  ["Montaga","serif",[400]],
  ["Montagu Slab","serif",[100,200,300,400,500,600,700]],
  ["MonteCarlo","handwriting",[400]],
  ["Montez","handwriting",[400]],
  ["Montserrat","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Montserrat Alternates","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Montserrat Subrayada","sans-serif",[400,700]],
  ["Moo Lah Lah","display",[400]],
  ["Mooli","sans-serif",[400]],
  ["Moon Dance","handwriting",[400]],
  ["Moul","display",[400]],
  ["Moulpali","sans-serif",[400]],
  ["Mountains of Christmas","display",[400,700]],
  ["Mouse Memoirs","sans-serif",[400]],
  ["Mr Bedfort","handwriting",[400]],
  ["Mr Dafoe","handwriting",[400]],
  ["Mr De Haviland","handwriting",[400]],
  ["Mrs Saint Delafield","handwriting",[400]],
  ["Mrs Sheppards","handwriting",[400]],
  ["Ms Madi","handwriting",[400]],
  ["Mukta","sans-serif",[200,300,400,500,600,700,800]],
  ["Mukta Mahee","sans-serif",[200,300,400,500,600,700,800]],
  ["Mukta Malar","sans-serif",[200,300,400,500,600,700,800]],
  ["Mukta Vaani","sans-serif",[200,300,400,500,600,700,800]],
  ["Mulish","sans-serif",[200,300,400,500,600,700,800,900]],
  ["Murecho","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["MuseoModerno","display",[100,200,300,400,500,600,700,800,900]],
  ["My Soul","handwriting",[400]],
  ["Mynerve","handwriting",[400]],
  ["Mystery Quest","display",[400]],
  ["NTR","sans-serif",[400]],
  ["Nabla","display",[400]],
  ["Nanum Brush Script","handwriting",[400]],
  ["Nanum Gothic","sans-serif",[400,700,800]],
  ["Nanum Gothic Coding","handwriting",[400,700]],
  ["Nanum Myeongjo","serif",[400,700,800]],
  ["Nanum Pen Script","handwriting",[400]],
  ["Narnoor","sans-serif",[400]],
  ["Neonderthaw","handwriting",[400]],
  ["Nerko One","handwriting",[400]],
  ["Neucha","handwriting",[400]],
  ["Neuton","serif",[200,300,400,700,800]],
  ["New Rocker","display",[400]],
  ["New Tegomin","serif",[400]],
  ["News Cycle","sans-serif",[400,700]],
  ["Newsreader","serif",[200,300,400,500,600,700,800]],
  ["Niconne","handwriting",[400]],
  ["Niramit","sans-serif",[200,300,400,500,600,700]],
  ["Nixie One","display",[400]],
  ["Nobile","sans-serif",[400,500,700]],
  ["Nokora","sans-serif",[100,300,400,700,900]],
  ["Norican","handwriting",[400]],
  ["Nosifer","display",[400]],
  ["Notable","sans-serif",[400]],
  ["Nothing You Could Do","handwriting",[400]],
  ["Noticia Text","serif",[400,700]],
  ["Noto Color Emoji","sans-serif",[400]],
  ["Noto Emoji","sans-serif",[300,400,500,600,700]],
  ["Noto Kufi Arabic","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Music","sans-serif",[400]],
  ["Noto Naskh Arabic","serif",[400,500,600,700]],
  ["Noto Nastaliq Urdu","serif",[400,500,600,700]],
  ["Noto Rashi Hebrew","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Adlam","sans-serif",[400,500,600,700]],
  ["Noto Sans Adlam Unjoined","sans-serif",[400,500,600,700]],
  ["Noto Sans Anatolian Hieroglyphs","sans-serif",[400]],
  ["Noto Sans Arabic","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Armenian","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Avestan","sans-serif",[400]],
  ["Noto Sans Balinese","sans-serif",[400,500,600,700]],
  ["Noto Sans Bamum","sans-serif",[400,500,600,700]],
  ["Noto Sans Bassa Vah","sans-serif",[400,500,600,700]],
  ["Noto Sans Batak","sans-serif",[400]],
  ["Noto Sans Bengali","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Bhaiksuki","sans-serif",[400]],
  ["Noto Sans Brahmi","sans-serif",[400]],
  ["Noto Sans Buginese","sans-serif",[400]],
  ["Noto Sans Buhid","sans-serif",[400]],
  ["Noto Sans Canadian Aboriginal","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Carian","sans-serif",[400]],
  ["Noto Sans Caucasian Albanian","sans-serif",[400]],
  ["Noto Sans Chakma","sans-serif",[400]],
  ["Noto Sans Cham","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Cherokee","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Chorasmian","sans-serif",[400]],
  ["Noto Sans Coptic","sans-serif",[400]],
  ["Noto Sans Cuneiform","sans-serif",[400]],
  ["Noto Sans Cypriot","sans-serif",[400]],
  ["Noto Sans Cypro Minoan","sans-serif",[400]],
  ["Noto Sans Deseret","sans-serif",[400]],
  ["Noto Sans Devanagari","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Display","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Duployan","sans-serif",[400,700]],
  ["Noto Sans Egyptian Hieroglyphs","sans-serif",[400]],
  ["Noto Sans Elbasan","sans-serif",[400]],
  ["Noto Sans Elymaic","sans-serif",[400]],
  ["Noto Sans Ethiopic","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Georgian","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Glagolitic","sans-serif",[400]],
  ["Noto Sans Gothic","sans-serif",[400]],
  ["Noto Sans Grantha","sans-serif",[400]],
  ["Noto Sans Gujarati","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Gunjala Gondi","sans-serif",[400,500,600,700]],
  ["Noto Sans Gurmukhi","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans HK","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Hanifi Rohingya","sans-serif",[400,500,600,700]],
  ["Noto Sans Hanunoo","sans-serif",[400]],
  ["Noto Sans Hatran","sans-serif",[400]],
  ["Noto Sans Hebrew","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Imperial Aramaic","sans-serif",[400]],
  ["Noto Sans Indic Siyaq Numbers","sans-serif",[400]],
  ["Noto Sans Inscriptional Pahlavi","sans-serif",[400]],
  ["Noto Sans Inscriptional Parthian","sans-serif",[400]],
  ["Noto Sans JP","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Javanese","sans-serif",[400,500,600,700]],
  ["Noto Sans KR","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Kaithi","sans-serif",[400]],
  ["Noto Sans Kannada","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Kayah Li","sans-serif",[400,500,600,700]],
  ["Noto Sans Kharoshthi","sans-serif",[400]],
  ["Noto Sans Khmer","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Khojki","sans-serif",[400]],
  ["Noto Sans Khudawadi","sans-serif",[400]],
  ["Noto Sans Lao","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Lao Looped","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Lepcha","sans-serif",[400]],
  ["Noto Sans Limbu","sans-serif",[400]],
  ["Noto Sans Linear A","sans-serif",[400]],
  ["Noto Sans Linear B","sans-serif",[400]],
  ["Noto Sans Lisu","sans-serif",[400,500,600,700]],
  ["Noto Sans Lycian","sans-serif",[400]],
  ["Noto Sans Lydian","sans-serif",[400]],
  ["Noto Sans Mahajani","sans-serif",[400]],
  ["Noto Sans Malayalam","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Mandaic","sans-serif",[400]],
  ["Noto Sans Manichaean","sans-serif",[400]],
  ["Noto Sans Marchen","sans-serif",[400]],
  ["Noto Sans Masaram Gondi","sans-serif",[400]],
  ["Noto Sans Math","sans-serif",[400]],
  ["Noto Sans Mayan Numerals","sans-serif",[400]],
  ["Noto Sans Medefaidrin","sans-serif",[400,500,600,700]],
  ["Noto Sans Meetei Mayek","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Mende Kikakui","sans-serif",[400]],
  ["Noto Sans Meroitic","sans-serif",[400]],
  ["Noto Sans Miao","sans-serif",[400]],
  ["Noto Sans Modi","sans-serif",[400]],
  ["Noto Sans Mongolian","sans-serif",[400]],
  ["Noto Sans Mono","monospace",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Mro","sans-serif",[400]],
  ["Noto Sans Multani","sans-serif",[400]],
  ["Noto Sans Myanmar","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans NKo","sans-serif",[400]],
  ["Noto Sans NKo Unjoined","sans-serif",[400,500,600,700]],
  ["Noto Sans Nabataean","sans-serif",[400]],
  ["Noto Sans Nag Mundari","sans-serif",[400,500,600,700]],
  ["Noto Sans Nandinagari","sans-serif",[400]],
  ["Noto Sans New Tai Lue","sans-serif",[400,500,600,700]],
  ["Noto Sans Newa","sans-serif",[400]],
  ["Noto Sans Nushu","sans-serif",[400]],
  ["Noto Sans Ogham","sans-serif",[400]],
  ["Noto Sans Ol Chiki","sans-serif",[400,500,600,700]],
  ["Noto Sans Old Hungarian","sans-serif",[400]],
  ["Noto Sans Old Italic","sans-serif",[400]],
  ["Noto Sans Old North Arabian","sans-serif",[400]],
  ["Noto Sans Old Permic","sans-serif",[400]],
  ["Noto Sans Old Persian","sans-serif",[400]],
  ["Noto Sans Old Sogdian","sans-serif",[400]],
  ["Noto Sans Old South Arabian","sans-serif",[400]],
  ["Noto Sans Old Turkic","sans-serif",[400]],
  ["Noto Sans Oriya","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Osage","sans-serif",[400]],
  ["Noto Sans Osmanya","sans-serif",[400]],
  ["Noto Sans Pahawh Hmong","sans-serif",[400]],
  ["Noto Sans Palmyrene","sans-serif",[400]],
  ["Noto Sans Pau Cin Hau","sans-serif",[400]],
  ["Noto Sans Phags Pa","sans-serif",[400]],
  ["Noto Sans Phoenician","sans-serif",[400]],
  ["Noto Sans Psalter Pahlavi","sans-serif",[400]],
  ["Noto Sans Rejang","sans-serif",[400]],
  ["Noto Sans Runic","sans-serif",[400]],
  ["Noto Sans SC","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Samaritan","sans-serif",[400]],
  ["Noto Sans Saurashtra","sans-serif",[400]],
  ["Noto Sans Sharada","sans-serif",[400]],
  ["Noto Sans Shavian","sans-serif",[400]],
  ["Noto Sans Siddham","sans-serif",[400]],
  ["Noto Sans SignWriting","sans-serif",[400]],
  ["Noto Sans Sinhala","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Sogdian","sans-serif",[400]],
  ["Noto Sans Sora Sompeng","sans-serif",[400,500,600,700]],
  ["Noto Sans Soyombo","sans-serif",[400]],
  ["Noto Sans Sundanese","sans-serif",[400,500,600,700]],
  ["Noto Sans Syloti Nagri","sans-serif",[400]],
  ["Noto Sans Symbols","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Symbols 2","sans-serif",[400]],
  ["Noto Sans Syriac","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Syriac Eastern","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans TC","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Tagalog","sans-serif",[400]],
  ["Noto Sans Tagbanwa","sans-serif",[400]],
  ["Noto Sans Tai Le","sans-serif",[400]],
  ["Noto Sans Tai Tham","sans-serif",[400,500,600,700]],
  ["Noto Sans Tai Viet","sans-serif",[400]],
  ["Noto Sans Takri","sans-serif",[400]],
  ["Noto Sans Tamil","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Tamil Supplement","sans-serif",[400]],
  ["Noto Sans Tangsa","sans-serif",[400,500,600,700]],
  ["Noto Sans Telugu","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Thaana","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Thai","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Thai Looped","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Sans Tifinagh","sans-serif",[400]],
  ["Noto Sans Tirhuta","sans-serif",[400]],
  ["Noto Sans Ugaritic","sans-serif",[400]],
  ["Noto Sans Vai","sans-serif",[400]],
  ["Noto Sans Vithkuqi","sans-serif",[400,500,600,700]],
  ["Noto Sans Wancho","sans-serif",[400]],
  ["Noto Sans Warang Citi","sans-serif",[400]],
  ["Noto Sans Yi","sans-serif",[400]],
  ["Noto Sans Zanabazar Square","sans-serif",[400]],
  ["Noto Serif","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Ahom","serif",[400]],
  ["Noto Serif Armenian","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Balinese","serif",[400]],
  ["Noto Serif Bengali","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Devanagari","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Display","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Dogra","serif",[400]],
  ["Noto Serif Ethiopic","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Georgian","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Grantha","serif",[400]],
  ["Noto Serif Gujarati","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Gurmukhi","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif HK","serif",[200,300,400,500,600,700,800,900]],
  ["Noto Serif Hebrew","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif JP","serif",[200,300,400,500,600,700,900]],
  ["Noto Serif KR","serif",[200,300,400,500,600,700,900]],
  ["Noto Serif Kannada","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Khitan Small Script","serif",[400]],
  ["Noto Serif Khmer","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Khojki","serif",[400,500,600,700]],
  ["Noto Serif Lao","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Makasar","serif",[400]],
  ["Noto Serif Malayalam","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Myanmar","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif NP Hmong","serif",[400,500,600,700]],
  ["Noto Serif Oriya","serif",[400,500,600,700]],
  ["Noto Serif Ottoman Siyaq","serif",[400]],
  ["Noto Serif SC","serif",[200,300,400,500,600,700,900]],
  ["Noto Serif Sinhala","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif TC","serif",[200,300,400,500,600,700,900]],
  ["Noto Serif Tamil","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Tangut","serif",[400]],
  ["Noto Serif Telugu","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Thai","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Tibetan","serif",[100,200,300,400,500,600,700,800,900]],
  ["Noto Serif Toto","serif",[400,500,600,700]],
  ["Noto Serif Vithkuqi","serif",[400,500,600,700]],
  ["Noto Serif Yezidi","serif",[400,500,600,700]],
  ["Noto Traditional Nushu","sans-serif",[300,400,500,600,700]],
  ["Nova Cut","display",[400]],
  ["Nova Flat","display",[400]],
  ["Nova Mono","monospace",[400]],
  ["Nova Oval","display",[400]],
  ["Nova Round","display",[400]],
  ["Nova Script","display",[400]],
  ["Nova Slim","display",[400]],
  ["Nova Square","display",[400]],
  ["Numans","sans-serif",[400]],
  ["Nunito","sans-serif",[200,300,400,500,600,700,800,900]],
  ["Nunito Sans","sans-serif",[200,300,400,500,600,700,800,900]],
  ["Nuosu SIL","sans-serif",[400]],
  ["Odibee Sans","display",[400]],
  ["Odor Mean Chey","serif",[400]],
  ["Offside","display",[400]],
  ["Oi","display",[400]],
  ["Old Standard TT","serif",[400,700]],
  ["Oldenburg","display",[400]],
  ["Ole","handwriting",[400]],
  ["Oleo Script","display",[400,700]],
  ["Oleo Script Swash Caps","display",[400,700]],
  ["Onest","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Oooh Baby","handwriting",[400]],
  ["Open Sans","sans-serif",[300,400,500,600,700,800]],
  ["Oranienbaum","serif",[400]],
  ["Orbit","sans-serif",[400]],
  ["Orbitron","sans-serif",[400,500,600,700,800,900]],
  ["Oregano","display",[400]],
  ["Orelega One","display",[400]],
  ["Orienta","sans-serif",[400]],
  ["Original Surfer","display",[400]],
  ["Oswald","sans-serif",[200,300,400,500,600,700]],
  ["Outfit","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Over the Rainbow","handwriting",[400]],
  ["Overlock","display",[400,700,900]],
  ["Overlock SC","display",[400]],
  ["Overpass","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Overpass Mono","monospace",[300,400,500,600,700]],
  ["Ovo","serif",[400]],
  ["Oxanium","display",[200,300,400,500,600,700,800]],
  ["Oxygen","sans-serif",[300,400,700]],
  ["Oxygen Mono","monospace",[400]],
  ["PT Mono","monospace",[400]],
  ["PT Sans","sans-serif",[400,700]],
  ["PT Sans Caption","sans-serif",[400,700]],
  ["PT Sans Narrow","sans-serif",[400,700]],
  ["PT Serif","serif",[400,700]],
  ["PT Serif Caption","serif",[400]],
  ["Pacifico","handwriting",[400]],
  ["Padauk","sans-serif",[400,700]],
  ["Padyakke Expanded One","serif",[400]],
  ["Palanquin","sans-serif",[100,200,300,400,500,600,700]],
  ["Palanquin Dark","sans-serif",[400,500,600,700]],
  ["Palette Mosaic","display",[400]],
  ["Pangolin","handwriting",[400]],
  ["Paprika","display",[400]],
  ["Parisienne","handwriting",[400]],
  ["Passero One","display",[400]],
  ["Passion One","display",[400,700,900]],
  ["Passions Conflict","handwriting",[400]],
  ["Pathway Extreme","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Pathway Gothic One","sans-serif",[400]],
  ["Patrick Hand","handwriting",[400]],
  ["Patrick Hand SC","handwriting",[400]],
  ["Pattaya","sans-serif",[400]],
  ["Patua One","display",[400]],
  ["Pavanam","sans-serif",[400]],
  ["Paytone One","sans-serif",[400]],
  ["Peddana","serif",[400]],
  ["Peralta","serif",[400]],
  ["Permanent Marker","handwriting",[400]],
  ["Petemoss","handwriting",[400]],
  ["Petit Formal Script","handwriting",[400]],
  ["Petrona","serif",[100,200,300,400,500,600,700,800,900]],
  ["Philosopher","sans-serif",[400,700]],
  ["Phudu","display",[300,400,500,600,700,800,900]],
  ["Piazzolla","serif",[100,200,300,400,500,600,700,800,900]],
  ["Piedra","display",[400]],
  ["Pinyon Script","handwriting",[400]],
  ["Pirata One","display",[400]],
  ["Pixelify Sans","display",[400,500,600,700]],
  ["Plaster","display",[400]],
  ["Play","sans-serif",[400,700]],
  ["Playball","display",[400]],
  ["Playfair","serif",[300,400,500,600,700,800,900]],
  ["Playfair Display","serif",[400,500,600,700,800,900]],
  ["Playfair Display SC","serif",[400,700,900]],
  ["Playpen Sans","handwriting",[100,200,300,400,500,600,700,800]],
  ["Plus Jakarta Sans","sans-serif",[200,300,400,500,600,700,800]],
  ["Podkova","serif",[400,500,600,700,800]],
  ["Poiret One","display",[400]],
  ["Poller One","display",[400]],
  ["Poltawski Nowy","serif",[400,500,600,700]],
  ["Poly","serif",[400]],
  ["Pompiere","display",[400]],
  ["Pontano Sans","sans-serif",[300,400,500,600,700]],
  ["Poor Story","display",[400]],
  ["Poppins","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Port Lligat Sans","sans-serif",[400]],
  ["Port Lligat Slab","serif",[400]],
  ["Potta One","display",[400]],
  ["Pragati Narrow","sans-serif",[400,700]],
  ["Praise","handwriting",[400]],
  ["Prata","serif",[400]],
  ["Preahvihear","sans-serif",[400]],
  ["Press Start 2P","display",[400]],
  ["Pridi","serif",[200,300,400,500,600,700]],
  ["Princess Sofia","handwriting",[400]],
  ["Prociono","serif",[400]],
  ["Prompt","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Prosto One","display",[400]],
  ["Proza Libre","sans-serif",[400,500,600,700,800]],
  ["Public Sans","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Puppies Play","handwriting",[400]],
  ["Puritan","sans-serif",[400,700]],
  ["Purple Purse","display",[400]],
  ["Qahiri","sans-serif",[400]],
  ["Quando","serif",[400]],
  ["Quantico","sans-serif",[400,700]],
  ["Quattrocento","serif",[400,700]],
  ["Quattrocento Sans","sans-serif",[400,700]],
  ["Questrial","sans-serif",[400]],
  ["Quicksand","sans-serif",[300,400,500,600,700]],
  ["Quintessential","handwriting",[400]],
  ["Qwigley","handwriting",[400]],
  ["Qwitcher Grypen","handwriting",[400,700]],
  ["REM","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Racing Sans One","display",[400]],
  ["Radio Canada","sans-serif",[300,400,500,600,700]],
  ["Radley","serif",[400]],
  ["Rajdhani","sans-serif",[300,400,500,600,700]],
  ["Rakkas","display",[400]],
  ["Raleway","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Raleway Dots","display",[400]],
  ["Ramabhadra","sans-serif",[400]],
  ["Ramaraja","serif",[400]],
  ["Rambla","sans-serif",[400,700]],
  ["Rammetto One","display",[400]],
  ["Rampart One","display",[400]],
  ["Ranchers","display",[400]],
  ["Rancho","handwriting",[400]],
  ["Ranga","display",[400,700]],
  ["Rasa","serif",[300,400,500,600,700]],
  ["Rationale","sans-serif",[400]],
  ["Ravi Prakash","display",[400]],
  ["Readex Pro","sans-serif",[200,300,400,500,600,700]],
  ["Recursive","sans-serif",[300,400,500,600,700,800,900]],
  ["Red Hat Display","sans-serif",[300,400,500,600,700,800,900]],
  ["Red Hat Mono","monospace",[300,400,500,600,700]],
  ["Red Hat Text","sans-serif",[300,400,500,600,700]],
  ["Red Rose","display",[300,400,500,600,700]],
  ["Redacted","display",[400]],
  ["Redacted Script","display",[300,400,700]],
  ["Redressed","handwriting",[400]],
  ["Reem Kufi","sans-serif",[400,500,600,700]],
  ["Reem Kufi Fun","sans-serif",[400,500,600,700]],
  ["Reem Kufi Ink","sans-serif",[400]],
  ["Reenie Beanie","handwriting",[400]],
  ["Reggae One","display",[400]],
  ["Revalia","display",[400]],
  ["Rhodium Libre","serif",[400]],
  ["Ribeye","display",[400]],
  ["Ribeye Marrow","display",[400]],
  ["Righteous","display",[400]],
  ["Risque","display",[400]],
  ["Road Rage","display",[400]],
  ["Roboto","sans-serif",[100,300,400,500,700,900]],
  ["Roboto Condensed","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Roboto Flex","sans-serif",[400]],
  ["Roboto Mono","monospace",[100,200,300,400,500,600,700]],
  ["Roboto Serif","serif",[100,200,300,400,500,600,700,800,900]],
  ["Roboto Slab","serif",[100,200,300,400,500,600,700,800,900]],
  ["Rochester","handwriting",[400]],
  ["Rock 3D","display",[400]],
  ["Rock Salt","handwriting",[400]],
  ["RocknRoll One","sans-serif",[400]],
  ["Rokkitt","serif",[100,200,300,400,500,600,700,800,900]],
  ["Romanesco","handwriting",[400]],
  ["Ropa Sans","sans-serif",[400]],
  ["Rosario","sans-serif",[300,400,500,600,700]],
  ["Rosarivo","serif",[400]],
  ["Rouge Script","handwriting",[400]],
  ["Rowdies","display",[300,400,700]],
  ["Rozha One","serif",[400]],
  ["Rubik","sans-serif",[300,400,500,600,700,800,900]],
  ["Rubik 80s Fade","display",[400]],
  ["Rubik Beastly","display",[400]],
  ["Rubik Bubbles","display",[400]],
  ["Rubik Burned","display",[400]],
  ["Rubik Dirt","display",[400]],
  ["Rubik Distressed","display",[400]],
  ["Rubik Gemstones","display",[400]],
  ["Rubik Glitch","display",[400]],
  ["Rubik Iso","display",[400]],
  ["Rubik Marker Hatch","display",[400]],
  ["Rubik Maze","display",[400]],
  ["Rubik Microbe","display",[400]],
  ["Rubik Mono One","sans-serif",[400]],
  ["Rubik Moonrocks","display",[400]],
  ["Rubik Pixels","display",[400]],
  ["Rubik Puddles","display",[400]],
  ["Rubik Spray Paint","display",[400]],
  ["Rubik Storm","display",[400]],
  ["Rubik Vinyl","display",[400]],
  ["Rubik Wet Paint","display",[400]],
  ["Ruda","sans-serif",[400,500,600,700,800,900]],
  ["Rufina","serif",[400,700]],
  ["Ruge Boogie","handwriting",[400]],
  ["Ruluko","sans-serif",[400]],
  ["Rum Raisin","sans-serif",[400]],
  ["Ruslan Display","display",[400]],
  ["Russo One","sans-serif",[400]],
  ["Ruthie","handwriting",[400]],
  ["Ruwudu","serif",[400,500,600,700]],
  ["Rye","display",[400]],
  ["STIX Two Text","serif",[400,500,600,700]],
  ["Sacramento","handwriting",[400]],
  ["Sahitya","serif",[400,700]],
  ["Sail","display",[400]],
  ["Saira","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Saira Condensed","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Saira Extra Condensed","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Saira Semi Condensed","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Saira Stencil One","display",[400]],
  ["Salsa","display",[400]],
  ["Sanchez","serif",[400]],
  ["Sancreek","display",[400]],
  ["Sansita","sans-serif",[400,700,800,900]],
  ["Sansita Swashed","display",[300,400,500,600,700,800,900]],
  ["Sarabun","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Sarala","sans-serif",[400,700]],
  ["Sarina","display",[400]],
  ["Sarpanch","sans-serif",[400,500,600,700,800,900]],
  ["Sassy Frass","handwriting",[400]],
  ["Satisfy","handwriting",[400]],
  ["Sawarabi Gothic","sans-serif",[400]],
  ["Sawarabi Mincho","serif",[400]],
  ["Scada","sans-serif",[400,700]],
  ["Scheherazade New","serif",[400,500,600,700]],
  ["Schibsted Grotesk","sans-serif",[400,500,600,700,800,900]],
  ["Schoolbell","handwriting",[400]],
  ["Scope One","serif",[400]],
  ["Seaweed Script","display",[400]],
  ["Secular One","sans-serif",[400]],
  ["Sedgwick Ave","handwriting",[400]],
  ["Sedgwick Ave Display","handwriting",[400]],
  ["Sen","sans-serif",[400,500,600,700,800]],
  ["Send Flowers","handwriting",[400]],
  ["Sevillana","display",[400]],
  ["Seymour One","sans-serif",[400]],
  ["Shadows Into Light","handwriting",[400]],
  ["Shadows Into Light Two","handwriting",[400]],
  ["Shalimar","handwriting",[400]],
  ["Shantell Sans","display",[300,400,500,600,700,800]],
  ["Shanti","sans-serif",[400]],
  ["Share","sans-serif",[400,700]],
  ["Share Tech","sans-serif",[400]],
  ["Share Tech Mono","monospace",[400]],
  ["Shippori Antique","sans-serif",[400]],
  ["Shippori Antique B1","sans-serif",[400]],
  ["Shippori Mincho","serif",[400,500,600,700,800]],
  ["Shippori Mincho B1","serif",[400,500,600,700,800]],
  ["Shizuru","display",[400]],
  ["Shojumaru","display",[400]],
  ["Short Stack","handwriting",[400]],
  ["Shrikhand","display",[400]],
  ["Siemreap","sans-serif",[400]],
  ["Sigmar","display",[400]],
  ["Sigmar One","display",[400]],
  ["Signika","sans-serif",[300,400,500,600,700]],
  ["Signika Negative","sans-serif",[300,400,500,600,700]],
  ["Silkscreen","display",[400,700]],
  ["Simonetta","display",[400,900]],
  ["Single Day","display",[400]],
  ["Sintony","sans-serif",[400,700]],
  ["Sirin Stencil","display",[400]],
  ["Six Caps","sans-serif",[400]],
  ["Skranji","display",[400,700]],
  ["Slabo 13px","serif",[400]],
  ["Slabo 27px","serif",[400]],
  ["Slackey","display",[400]],
  ["Slackside One","handwriting",[400]],
  ["Smokum","display",[400]],
  ["Smooch","handwriting",[400]],
  ["Smooch Sans","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Smythe","display",[400]],
  ["Sniglet","display",[400,800]],
  ["Snippet","sans-serif",[400]],
  ["Snowburst One","display",[400]],
  ["Sofadi One","display",[400]],
  ["Sofia","handwriting",[400]],
  ["Sofia Sans","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Sofia Sans Condensed","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Sofia Sans Extra Condensed","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Sofia Sans Semi Condensed","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Solitreo","handwriting",[400]],
  ["Solway","serif",[300,400,500,700,800]],
  ["Sometype Mono","monospace",[400,500,600,700]],
  ["Song Myung","serif",[400]],
  ["Sono","sans-serif",[200,300,400,500,600,700,800]],
  ["Sonsie One","display",[400]],
  ["Sora","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Sorts Mill Goudy","serif",[400]],
  ["Source Code Pro","monospace",[200,300,400,500,600,700,800,900]],
  ["Source Sans 3","sans-serif",[200,300,400,500,600,700,800,900]],
  ["Source Serif 4","serif",[200,300,400,500,600,700,800,900]],
  ["Space Grotesk","sans-serif",[300,400,500,600,700]],
  ["Space Mono","monospace",[400,700]],
  ["Special Elite","display",[400]],
  ["Spectral","serif",[200,300,400,500,600,700,800]],
  ["Spectral SC","serif",[200,300,400,500,600,700,800]],
  ["Spicy Rice","display",[400]],
  ["Spinnaker","sans-serif",[400]],
  ["Spirax","display",[400]],
  ["Splash","handwriting",[400]],
  ["Spline Sans","sans-serif",[300,400,500,600,700]],
  ["Spline Sans Mono","monospace",[300,400,500,600,700]],
  ["Squada One","display",[400]],
  ["Square Peg","handwriting",[400]],
  ["Sree Krushnadevaraya","serif",[400]],
  ["Sriracha","handwriting",[400]],
  ["Srisakdi","display",[400,700]],
  ["Staatliches","display",[400]],
  ["Stalemate","handwriting",[400]],
  ["Stalinist One","display",[400]],
  ["Stardos Stencil","display",[400,700]],
  ["Stick","sans-serif",[400]],
  ["Stick No Bills","sans-serif",[200,300,400,500,600,700,800]],
  ["Stint Ultra Condensed","serif",[400]],
  ["Stint Ultra Expanded","serif",[400]],
  ["Stoke","serif",[300,400]],
  ["Strait","sans-serif",[400]],
  ["Style Script","handwriting",[400]],
  ["Stylish","sans-serif",[400]],
  ["Sue Ellen Francisco","handwriting",[400]],
  ["Suez One","serif",[400]],
  ["Sulphur Point","sans-serif",[300,400,700]],
  ["Sumana","serif",[400,700]],
  ["Sunflower","sans-serif",[300,500,700]],
  ["Sunshiney","handwriting",[400]],
  ["Supermercado One","display",[400]],
  ["Sura","serif",[400,700]],
  ["Suranna","serif",[400]],
  ["Suravaram","serif",[400]],
  ["Suwannaphum","serif",[100,300,400,700,900]],
  ["Swanky and Moo Moo","handwriting",[400]],
  ["Syncopate","sans-serif",[400,700]],
  ["Syne","sans-serif",[400,500,600,700,800]],
  ["Syne Mono","monospace",[400]],
  ["Syne Tactile","display",[400]],
  ["Tai Heritage Pro","serif",[400,700]],
  ["Tajawal","sans-serif",[200,300,400,500,700,800,900]],
  ["Tangerine","handwriting",[400,700]],
  ["Tapestry","handwriting",[400]],
  ["Taprom","display",[400]],
  ["Tauri","sans-serif",[400]],
  ["Taviraj","serif",[100,200,300,400,500,600,700,800,900]],
  ["Teko","sans-serif",[300,400,500,600,700]],
  ["Tektur","display",[400,500,600,700,800,900]],
  ["Telex","sans-serif",[400]],
  ["Tenali Ramakrishna","sans-serif",[400]],
  ["Tenor Sans","sans-serif",[400]],
  ["Text Me One","sans-serif",[400]],
  ["Texturina","serif",[100,200,300,400,500,600,700,800,900]],
  ["Thasadith","sans-serif",[400,700]],
  ["The Girl Next Door","handwriting",[400]],
  ["The Nautigal","handwriting",[400,700]],
  ["Tienne","serif",[400,700,900]],
  ["Tillana","display",[400,500,600,700,800]],
  ["Tilt Neon","display",[400]],
  ["Tilt Prism","display",[400]],
  ["Tilt Warp","display",[400]],
  ["Timmana","sans-serif",[400]],
  ["Tinos","serif",[400,700]],
  ["Tiro Bangla","serif",[400]],
  ["Tiro Devanagari Hindi","serif",[400]],
  ["Tiro Devanagari Marathi","serif",[400]],
  ["Tiro Devanagari Sanskrit","serif",[400]],
  ["Tiro Gurmukhi","serif",[400]],
  ["Tiro Kannada","serif",[400]],
  ["Tiro Tamil","serif",[400]],
  ["Tiro Telugu","serif",[400]],
  ["Titan One","display",[400]],
  ["Titillium Web","sans-serif",[200,300,400,600,700,900]],
  ["Tomorrow","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Tourney","display",[100,200,300,400,500,600,700,800,900]],
  ["Trade Winds","display",[400]],
  ["Train One","display",[400]],
  ["Trirong","serif",[100,200,300,400,500,600,700,800,900]],
  ["Trispace","sans-serif",[100,200,300,400,500,600,700,800]],
  ["Trocchi","serif",[400]],
  ["Trochut","display",[400,700]],
  ["Truculenta","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Trykker","serif",[400]],
  ["Tsukimi Rounded","sans-serif",[300,400,500,600,700]],
  ["Tulpen One","display",[400]],
  ["Turret Road","display",[200,300,400,500,700,800]],
  ["Twinkle Star","handwriting",[400]],
  ["Ubuntu","sans-serif",[300,400,500,700]],
  ["Ubuntu Condensed","sans-serif",[400]],
  ["Ubuntu Mono","monospace",[400,700]],
  ["Uchen","serif",[400]],
  ["Ultra","serif",[400]],
  ["Unbounded","sans-serif",[200,300,400,500,600,700,800,900]],
  ["Uncial Antiqua","display",[400]],
  ["Underdog","display",[400]],
  ["Unica One","display",[400]],
  ["UnifrakturCook","display",[700]],
  ["UnifrakturMaguntia","display",[400]],
  ["Unkempt","display",[400,700]],
  ["Unlock","display",[400]],
  ["Unna","serif",[400,700]],
  ["Updock","handwriting",[400]],
  ["Urbanist","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["VT323","monospace",[400]],
  ["Vampiro One","display",[400]],
  ["Varela","sans-serif",[400]],
  ["Varela Round","sans-serif",[400]],
  ["Varta","sans-serif",[300,400,500,600,700]],
  ["Vast Shadow","serif",[400]],
  ["Vazirmatn","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Vesper Libre","serif",[400,500,700,900]],
  ["Viaoda Libre","display",[400]],
  ["Vibes","display",[400]],
  ["Vibur","handwriting",[400]],
  ["Victor Mono","monospace",[100,200,300,400,500,600,700]],
  ["Vidaloka","serif",[400]],
  ["Viga","sans-serif",[400]],
  ["Vina Sans","display",[400]],
  ["Voces","sans-serif",[400]],
  ["Volkhov","serif",[400,700]],
  ["Vollkorn","serif",[400,500,600,700,800,900]],
  ["Vollkorn SC","serif",[400,600,700,900]],
  ["Voltaire","sans-serif",[400]],
  ["Vujahday Script","handwriting",[400]],
  ["Waiting for the Sunrise","handwriting",[400]],
  ["Wallpoet","display",[400]],
  ["Walter Turncoat","handwriting",[400]],
  ["Warnes","display",[400]],
  ["Water Brush","handwriting",[400]],
  ["Waterfall","handwriting",[400]],
  ["Wavefont","display",[100,200,300,400,500,600,700,800,900]],
  ["Wellfleet","serif",[400]],
  ["Wendy One","sans-serif",[400]],
  ["Whisper","handwriting",[400]],
  ["WindSong","handwriting",[400,500]],
  ["Wire One","sans-serif",[400]],
  ["Wix Madefor Display","sans-serif",[400,500,600,700,800]],
  ["Wix Madefor Text","sans-serif",[400,500,600,700,800]],
  ["Work Sans","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Xanh Mono","monospace",[400]],
  ["Yaldevi","sans-serif",[200,300,400,500,600,700]],
  ["Yanone Kaffeesatz","sans-serif",[200,300,400,500,600,700]],
  ["Yantramanav","sans-serif",[100,300,400,500,700,900]],
  ["Yatra One","display",[400]],
  ["Yellowtail","handwriting",[400]],
  ["Yeon Sung","display",[400]],
  ["Yeseva One","display",[400]],
  ["Yesteryear","handwriting",[400]],
  ["Yomogi","handwriting",[400]],
  ["Young Serif","serif",[400]],
  ["Yrsa","serif",[300,400,500,600,700]],
  ["Ysabeau","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Ysabeau Infant","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Ysabeau Office","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Ysabeau SC","sans-serif",[100,200,300,400,500,600,700,800,900]],
  ["Yuji Boku","serif",[400]],
  ["Yuji Hentaigana Akari","handwriting",[400]],
  ["Yuji Hentaigana Akebono","handwriting",[400]],
  ["Yuji Mai","serif",[400]],
  ["Yuji Syuku","serif",[400]],
  ["Yusei Magic","sans-serif",[400]],
  ["ZCOOL KuaiLe","sans-serif",[400]],
  ["ZCOOL QingKe HuangYou","sans-serif",[400]],
  ["ZCOOL XiaoWei","sans-serif",[400]],
  ["Zen Antique","serif",[400]],
  ["Zen Antique Soft","serif",[400]],
  ["Zen Dots","display",[400]],
  ["Zen Kaku Gothic Antique","sans-serif",[300,400,500,700,900]],
  ["Zen Kaku Gothic New","sans-serif",[300,400,500,700,900]],
  ["Zen Kurenaido","sans-serif",[400]],
  ["Zen Loop","display",[400]],
  ["Zen Maru Gothic","sans-serif",[300,400,500,700,900]],
  ["Zen Old Mincho","serif",[400,500,600,700,900]],
  ["Zen Tokyo Zoo","display",[400]],
  ["Zeyada","handwriting",[400]],
  ["Zhi Mang Xing","handwriting",[400]],
  ["Zilla Slab","serif",[300,400,500,600,700]],
  ["Zilla Slab Highlight","serif",[400,700]],
] as const;

export const GOOGLE_FONT_NAMES: readonly string[] = GOOGLE_FONTS.map((f) => f[0]);

export function findGoogleFont(name: string | null | undefined): GoogleFont | undefined {
  if (!name) return undefined;
  const lc = name.toLowerCase();
  return GOOGLE_FONTS.find((f) => f[0].toLowerCase() === lc);
}

/** Build a Google Fonts CSS2 stylesheet URL for a deduped set of families/weights. */
export function buildGoogleFontsHref(specs: Array<{ family: string; weights?: number[] }>): string | null {
  const map = new Map<string, Set<number>>();
  for (const s of specs) {
    if (!s.family) continue;
    const meta = findGoogleFont(s.family);
    if (!meta) continue;
    const valid = new Set(meta[2]);
    const want  = (s.weights ?? [400, 700]).filter((w) => valid.has(w));
    if (!want.length) want.push(meta[2][0] ?? 400);
    const cur = map.get(meta[0]) ?? new Set<number>();
    for (const w of want) cur.add(w);
    map.set(meta[0], cur);
  }
  if (!map.size) return null;
  const params = [...map.entries()].map(([fam, ws]) =>
    `family=${encodeURIComponent(fam).replace(/%20/g, "+")}:wght@${[...ws].sort((a, b) => a - b).join(";")}`
  );
  return `https://fonts.googleapis.com/css2?${params.join("&")}&display=swap`;
}
